<template lang="pug">

  div

    .createTurnField.createTurnField--first

      label.csLabel
        span(v-html="'Data'")

      .csFields.csFields--date
        date-picker(v-model="selectedDate" :clearable="false" :editable="false" valueType="format" format="DD/MM/YYYY" :lang="lang" class="groupUserField--date" :disabled="loading")

    .dailyReportHours

      daily-report-time-item(:shiftTime="'00:00'" :timeDoctors="doctorsPerTime['00:00']" :loading="loading")
      daily-report-time-item(:shiftTime="'01:00'" :timeDoctors="doctorsPerTime['01:00']" :loading="loading")
      daily-report-time-item(:shiftTime="'02:00'" :timeDoctors="doctorsPerTime['02:00']" :loading="loading")
      daily-report-time-item(:shiftTime="'03:00'" :timeDoctors="doctorsPerTime['03:00']" :loading="loading")
      daily-report-time-item(:shiftTime="'04:00'" :timeDoctors="doctorsPerTime['04:00']" :loading="loading")
      daily-report-time-item(:shiftTime="'05:00'" :timeDoctors="doctorsPerTime['05:00']" :loading="loading")
      daily-report-time-item(:shiftTime="'06:00'" :timeDoctors="doctorsPerTime['06:00']" :loading="loading")
      daily-report-time-item(:shiftTime="'07:00'" :timeDoctors="doctorsPerTime['07:00']" :loading="loading")
      daily-report-time-item(:shiftTime="'08:00'" :timeDoctors="doctorsPerTime['08:00']" :loading="loading")
      daily-report-time-item(:shiftTime="'09:00'" :timeDoctors="doctorsPerTime['09:00']" :loading="loading")
      daily-report-time-item(:shiftTime="'10:00'" :timeDoctors="doctorsPerTime['10:00']" :loading="loading")
      daily-report-time-item(:shiftTime="'11:00'" :timeDoctors="doctorsPerTime['11:00']" :loading="loading")
      daily-report-time-item(:shiftTime="'12:00'" :timeDoctors="doctorsPerTime['12:00']" :loading="loading")
      daily-report-time-item(:shiftTime="'13:00'" :timeDoctors="doctorsPerTime['13:00']" :loading="loading")
      daily-report-time-item(:shiftTime="'14:00'" :timeDoctors="doctorsPerTime['14:00']" :loading="loading")
      daily-report-time-item(:shiftTime="'15:00'" :timeDoctors="doctorsPerTime['15:00']" :loading="loading")
      daily-report-time-item(:shiftTime="'16:00'" :timeDoctors="doctorsPerTime['16:00']" :loading="loading")
      daily-report-time-item(:shiftTime="'17:00'" :timeDoctors="doctorsPerTime['17:00']" :loading="loading")
      daily-report-time-item(:shiftTime="'18:00'" :timeDoctors="doctorsPerTime['18:00']" :loading="loading")
      daily-report-time-item(:shiftTime="'19:00'" :timeDoctors="doctorsPerTime['19:00']" :loading="loading")
      daily-report-time-item(:shiftTime="'20:00'" :timeDoctors="doctorsPerTime['20:00']" :loading="loading")
      daily-report-time-item(:shiftTime="'21:00'" :timeDoctors="doctorsPerTime['21:00']" :loading="loading")
      daily-report-time-item(:shiftTime="'22:00'" :timeDoctors="doctorsPerTime['22:00']" :loading="loading")
      daily-report-time-item(:shiftTime="'23:00'" :timeDoctors="doctorsPerTime['23:00']" :loading="loading")

</template>

<script>

  //
  // DATE PICKER
  //

  import DatePicker from 'vue2-datepicker'
  import 'vue2-datepicker/index.css'

  //
  // moment
  //

  import moment from 'moment'
  import 'moment/locale/pt-br'
  // moment.locale('pt-BR')

  //
  //
  //

  import { /* nomeAbrev, primeiroNome, */ firstLastName } from '@/mixins/utils.js'

  import userProfileBroken from '@/assets/images/user-profile-broken.png'

  //
  //
  //

  import { rgxFirebaseKey, apiGetUserDetails } from '@/services/firebase'

  import { apiGetDailyReportDuties } from '@/services/duties'

  //
  //
  //

  import DailyReportTimeItem from './dailyReportTimeItem'

  //
  //
  //

  export default {
    name: 'DailyReport',

    components: {
      'date-picker': DatePicker,
      'daily-report-time-item': DailyReportTimeItem,
    },

    data () {
      return {
        // LOADING STATUS
        loading: false,

        // SELECTED DATE
        selectedDate: '',

        // DATEPICKER LANGUAGE SETTINGS
        lang: {
          formatLocale: {
            months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'], // MMMM
            monthsShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'], // MMM
            weekdays: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'], // dddd
            weekdaysShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'], // ddd
            weekdaysMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'], // dd
            // weekdaysMin: ['Do', 'Se', 'Te', 'Qu', 'Qu', 'Se', 'Sa'], // dd
          },
          yearFormat: 'YYYY',
          monthFormat: 'MMMM',
        },

        // DOCTORS PER SHIFT TIME
        doctorsPerTime: { '00:00': [], '01:00': [], '02:00': [], '03:00': [], '04:00': [], '05:00': [], '06:00': [], '07:00': [], '08:00': [], '09:00': [], '10:00': [], '11:00': [], '12:00': [], '13:00': [], '14:00': [], '15:00': [], '16:00': [], '17:00': [], '18:00': [], '19:00': [], '20:00': [], '21:00': [], '22:00': [], '23:00': [] },

        // USERS CACHE
        memoryUsers: [],

        // BROKEN USER PICTURE
        userProfileBroken,
      }
    },

    watch: {
      selectedDate: {
        immediate: true,
        handler (newDailyReportDate, oldDailyReportDate) {
          if (newDailyReportDate !== oldDailyReportDate && newDailyReportDate.length === 10) this.loadDailyDuties(newDailyReportDate)
        },
      },
    },

    mounted () {
      this.selectedDate = moment().format('DD/MM/YYYY')

      // [24/01/25] console.log('::: dailyReport:', this.selectedDate)
    },

    methods: {
      //
      //
      //

      memoryGetUsers () {
        return this.memoryUsers
      },

      memoryGetUserById (userId) {
        const uid = String(userId)
        return this.memoryUsers.find(user => user.userID === uid)
      },

      memoryAppendUser (userToAppend) {
        this.memoryUsers = [
          ...this.memoryUsers,
          {
            userID: String(userToAppend.userID),
            userName: String(userToAppend.userName),
            userImage: String(userToAppend.userImage),
          },
        ]
      },

      //
      //
      //

      async loadDailyDuties (date)
      {
        if (this.loading === true) {
          // [24/01/25] console.log('::: RELATÓRIO DO DIA -> Não foi possível ler o relatório do dia. A função está processando...', date)
          return false
        }

        // [24/01/25] console.log('::: RELATÓRIO DO DIA -> DATA SELECIONADA:', date)

        this.loading = true
        this.$emit('loading', true)

        this.resetShifts()

        /**
         *
         * CARREGA OS PLANTÕES DO DIA SELECIONADO
         *
         */

        const { groupID } = this.$route.params

        const today = date.split('/')
        const todayDay = parseInt(today[0])
        const todayMonth = parseInt(today[1])
        const todayYear = parseInt(today[2])

        const dutiesResponse = await apiGetDailyReportDuties(groupID, todayDay, todayMonth, todayYear)
        const dutiesKeys = dutiesResponse ? Object.keys(dutiesResponse) : []

        const duties = dutiesKeys.length > 0 ? (await Promise.all(
          dutiesKeys.map(async dutyID => {
            const duty = dutiesResponse[dutyID]

            // PROCESSA APENAS PLANTÕES ASSUMIDOS

            const isValid = !!duty === true && !!duty.uid_pegou === true && rgxFirebaseKey.test(duty.uid_pegou)
            if (!isValid) return false

            // BUSCA OS DADOS DO PLANTONISTA NO STATE DO COMPONENTE
            // SE ESSE PLANTONISTA AINDA NÃO FOI CARREGADO, CARREGA E COLOCA NO STATE DO COMPONENTE

            let doctor = this.memoryGetUserById(duty.uid_pegou)

            if (!!doctor === false) {
              doctor = await apiGetUserDetails(duty.uid_pegou)

              if (doctor) {
                doctor.userID = duty.uid_pegou
                doctor.userName = doctor.nome || ''
                doctor.userImage = doctor.img || userProfileBroken

                this.memoryAppendUser({ userID: doctor.userID, userName: doctor.userName, userImage: doctor.userImage })
              }
            }

            const dutyDuration = String(duty.periodo)

            const output = {
              doctor: !!doctor === true ? {
                userID: doctor.userID,
                userName: doctor.userName,
                userImage: doctor.userImage,
              } : {
                userID: duty.uid_pegou,
                userName: duty.uid_pegou,
                userImage: userProfileBroken,
              },
              tz: duty.dutyStartDateTZ || '',
              date: duty.data_inicio,
              time: duty.hora_inicio,
              duration: dutyDuration.length === 5 ? dutyDuration : (dutyDuration.padStart(2, '0') + ':00'),
            }

            return output
          })
        )).filter(fi => !!fi === true) : []

        /**
         *
         * CONTABILIZAR
         *
         */

        // ZERA CONTAGEM DE PLANTONISTAS EM CADA HORÁRIO DO DIA SELECIONADO

        const shifts = [
          '00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00',
          '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00',
        ]

        /* shifts.forEach(shift => {
          this.dailyReportTimeStatus[shift] = false
          this.doctorsPerTime[shift] = []
        }) */

        this.resetShifts()

        // [24/01/25] console.log('::: duties:', duties)

        // PERCORRE TODOS OS PLANTÕES DO DIA SELECIONADO E PARA CADA PLANTÃO/PLANTONISTA,
        // PERCORRE TODAS AS HORAS DO DIA E VERIFICA QUAIS HORAS SÃO ATENDIDAS POR ESSE PLANTONISTA

        duties.forEach(duty => {
          // hoursInSeconds + minutesInSeconds
          const dutyDuration = duty.duration.split(':')
          const dutyDurationInSeconds = (dutyDuration[0] !== '00' ? (dutyDuration[0] * 60 * 60) : 0) + (dutyDuration[1] !== '00' ? (dutyDuration[1] * 60) : 0)

          const dutyDate = (duty.tz === '+0000' ? moment.utc(duty.date) : moment(duty.date)).format('YYYY-MM-DD')
          const dutyStartDateTime = duty.tz === '+0000' ? moment.utc(`${dutyDate} ${duty.time}:00`, 'YYYY-MM-DD HH:mm:ss') : moment(`${dutyDate} ${duty.time}:00`, 'YYYY-MM-DD HH:mm:ss')

          const startTime = dutyStartDateTime
          const endTime = dutyStartDateTime.clone().add(dutyDurationInSeconds - 1, 's')

          const startTimeFmt = startTime.format('DD/MM/YYYY HH:mm:ss')
          const endTimeFmt = endTime.format('DD/MM/YYYY HH:mm:ss')

          /**
           *
           * TODAY SHIFTS
           *
           */

          shifts.forEach(shift => {
            const shiftSplit = shift.split(':')
            const shiftHour = parseInt(shiftSplit[0])
            const shiftMinutes = parseInt(shiftSplit[1])
            const shiftStartTime = moment.utc([todayYear, todayMonth - 1, todayDay, shiftHour, shiftMinutes, 0, 0])

            // console.log(`::: SHIFT[${shift}]:`, startTime, endTime)

            if (
              shiftStartTime.isBetween(startTime, endTime) ||
              shiftStartTime.isSame(startTime, 'hour') ||
              shiftStartTime.isSame(endTime, 'hour')
            ) {
              this.doctorsPerTime[shift].push({
                doctorID: duty.doctor.userID,
                doctorName: duty.doctor.userName,
                doctorImage: duty.doctor.userImage,
                doctorShift: `Plantonista: ${duty.doctor.userName}\nInício: ${startTimeFmt}\nFim: ${endTimeFmt}`,
                doctorShortName: firstLastName(duty.doctor.userName),
                doctorStart: startTimeFmt,
                doctorEnd: endTimeFmt,
                shiftDuration: (dutyDuration[0] !== '00' ? (dutyDuration[0] + 'h') : '') + (dutyDuration[1] !== '00' ? (dutyDuration[1] + 'm') : ''),
              })
            }
          })
        })

        this.loading = false
        this.$emit('loading', false)

        // [24/01/25] console.log('::: RELATÓRIO DO DIA -> PLANTÕES:', this.memoryGetUsers(), duties)
      },

      //
      //
      //

      resetShifts () {
        this.doctorsPerTime = { '00:00': [], '01:00': [], '02:00': [], '03:00': [], '04:00': [], '05:00': [], '06:00': [], '07:00': [], '08:00': [], '09:00': [], '10:00': [], '11:00': [], '12:00': [], '13:00': [], '14:00': [], '15:00': [], '16:00': [], '17:00': [], '18:00': [], '19:00': [], '20:00': [], '21:00': [], '22:00': [], '23:00': [] }
      },
    },
  }

</script>

<style lang="sass" scoped>

  .groupUserField--date
    width: 100%

  .dailyReportHours
    margin: 10px auto 0 auto

</style>
